/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */
import type {
  GetMatches200,
  GetMatchesParams,
  GetTickets200,
  Predict200,
  PredictionHistory200,
  PredictionHistoryParams,
  WorldcupEventOverviewResponse,
  WorldcupPredictRequest,
} from '.././model';

/**
 * 경기당 1~3장 티켓 투입. 예측 마감(경기 시작 2시간 전) 이후·이미 예측한 경기는 불가. 변경·취소 불가.
 * @summary 경기 예측 제출
 */
export type predictResponse200 = {
  data: Predict200;
  status: 200;
};

export type predictResponseSuccess = predictResponse200 & {
  headers: Headers;
};
export type predictResponse = predictResponseSuccess;

export const getPredictUrl = () => {
  return `/worldcup/predict`;
};

export const predict = async (
  worldcupPredictRequest: WorldcupPredictRequest,
  options?: RequestInit,
): Promise<predictResponse> => {
  const res = await fetch(getPredictUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(worldcupPredictRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: predictResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as predictResponse;
};

/**
 * 보유 티켓 수, 일일 최대 획득 한도, 게임별 오늘 지급 여부를 반환합니다.
 * @summary 보유 티켓 및 일일 획득 현황
 */
export type getTicketsResponse200 = {
  data: GetTickets200;
  status: 200;
};

export type getTicketsResponseSuccess = getTicketsResponse200 & {
  headers: Headers;
};
export type getTicketsResponse = getTicketsResponseSuccess;

export const getGetTicketsUrl = () => {
  return `/worldcup/tickets`;
};

export const getTickets = async (options?: RequestInit): Promise<getTicketsResponse> => {
  const res = await fetch(getGetTicketsUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getTicketsResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as getTicketsResponse;
};

/**
 * 유저의 예측 이력을 최신순으로 반환합니다.
 * @summary 내 예측 이력
 */
export type predictionHistoryResponse200 = {
  data: PredictionHistory200;
  status: 200;
};

export type predictionHistoryResponseSuccess = predictionHistoryResponse200 & {
  headers: Headers;
};
export type predictionHistoryResponse = predictionHistoryResponseSuccess;

export const getPredictionHistoryUrl = (params?: PredictionHistoryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/worldcup/predictions/history?${stringifiedParams}`
    : `/worldcup/predictions/history`;
};

export const predictionHistory = async (
  params?: PredictionHistoryParams,
  options?: RequestInit,
): Promise<predictionHistoryResponse> => {
  const res = await fetch(getPredictionHistoryUrl(params), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: predictionHistoryResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as predictionHistoryResponse;
};

/**
 * 선택한 라운드의 경기 카드 목록. 각 경기에 uiStatus, 팀 정보, 내 예측, 풀·예상 지급액이 포함됩니다.
 * @summary 라운드별 경기 목록 조회
 */
export type getMatchesResponse200 = {
  data: GetMatches200;
  status: 200;
};

export type getMatchesResponseSuccess = getMatchesResponse200 & {
  headers: Headers;
};
export type getMatchesResponse = getMatchesResponseSuccess;

export const getGetMatchesUrl = (params: GetMatchesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/worldcup/matches?${stringifiedParams}` : `/worldcup/matches`;
};

export const getMatches = async (params: GetMatchesParams, options?: RequestInit): Promise<getMatchesResponse> => {
  const res = await fetch(getGetMatchesUrl(params), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMatchesResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as getMatchesResponse;
};

/**
 * 진행 중인 이벤트, 토너먼트 라운드 목록, 현재 OPEN 라운드 코드를 반환합니다. JWT 불필요.
 * @summary 이벤트 및 라운드 탭 조회
 */
export type getEventResponse200 = {
  data: WorldcupEventOverviewResponse;
  status: 200;
};

export type getEventResponseSuccess = getEventResponse200 & {
  headers: Headers;
};
export type getEventResponse = getEventResponseSuccess;

export const getGetEventUrl = () => {
  return `/worldcup/event`;
};

export const getEvent = async (options?: RequestInit): Promise<getEventResponse> => {
  const res = await fetch(getGetEventUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getEventResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as getEventResponse;
};
